module.exports = __webpack_public_path__ + "static/img/testlogo.1c5d8f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testlogo.png
// module id = 1X0N
// module chunks = 0